import React from 'react';
import { Link } from 'react-router-dom';
import Icon from '../../../components/AppIcon';

const QuickAccessTiles = ({ onTileClick }) => {
  const tiles = [
    {
      id: 'bible-reader',
      title: 'Bible Reader',
      description: 'Read and discover verses',
      icon: 'BookOpen',
      color: 'var(--color-accent)',
      bgColor: 'bg-accent/10',
      hoverBorder: 'hover:border-accent/40',
      hoverText: 'group-hover:text-accent',
      route: '/bible-reader'
    },
    {
      id: 'tutorial',
      title: 'Tutorial',
      description: 'Learn how to use the app',
      icon: 'BookMarked',
      color: 'var(--color-accent)',
      bgColor: 'bg-accent/10',
      hoverBorder: 'hover:border-accent/40',
      hoverText: 'group-hover:text-accent',
      route: '/tutorial'
    },
    {
      id: 'verse-library',
      title: 'My Verses',
      description: 'Browse your saved verses',
      icon: 'Heart',
      color: 'var(--color-primary)',
      bgColor: 'bg-primary/10',
      hoverBorder: 'hover:border-primary/40',
      hoverText: 'group-hover:text-primary',
      route: '/verse-library'
    },
    {
      id: 'memorization',
      title: 'Memorization',
      description: 'Interactive memorization',
      icon: 'Brain',
      color: 'var(--color-success)',
      bgColor: 'bg-success/10',
      hoverBorder: 'hover:border-success/40',
      hoverText: 'group-hover:text-success',
      route: '/memorization-practice'
    },
    {
      id: 'study-analytics',
      title: 'Study Analytics',
      description: 'Track your progress',
      icon: 'BarChart3',
      color: 'var(--color-warning)',
      bgColor: 'bg-warning/10',
      hoverBorder: 'hover:border-warning/40',
      hoverText: 'group-hover:text-warning',
      route: '/study-analytics-dashboard'
    },
    {
      id: 'study-notes',
      title: 'Study Notes',
      description: 'Create sermon presentations',
      icon: 'FileText',
      color: 'var(--color-success)',
      bgColor: 'bg-success/10',
      hoverBorder: 'hover:border-success/40',
      hoverText: 'group-hover:text-success',
      route: '/tools/notes'
    }
  ];

  const handleTileClick = (tile) => {
    onTileClick?.(tile);
  };

  return (
    <div className="group/container bg-gradient-to-br from-card via-card to-primary/5 rounded-xl p-6 shadow-lg border border-border hover:shadow-xl hover:border-primary/20 transition-all duration-300 ease-out">
      <div className="flex items-center justify-between mb-6">
        <h2 className="text-lg font-heading font-semibold text-foreground group-hover/container:text-primary transition-colors duration-300">Quick Access</h2>
        <Icon name="Grid3X3" size={18} className="text-muted-foreground" />
      </div>
      <div className="grid grid-cols-2 lg:grid-cols-5 gap-3">
        {tiles?.map((tile) => (
          <Link
            key={tile?.id}
            to={tile?.route}
            onClick={() => handleTileClick(tile)}
            className={`group block p-2.5 bg-gradient-to-br from-background/50 to-background/80 rounded-lg border border-border/50 hover:border-border hover:shadow-md hover:scale-[1.06] active:scale-[0.97] ${tile?.hoverBorder} transition-all duration-250 ease-out`}
          >
            <div className="flex items-start justify-between mb-2">
              <div className={`flex items-center justify-center w-8 h-8 ${tile?.bgColor} rounded-lg group-hover:scale-110 group-hover:shadow-sm transition-all duration-250`}>
                <Icon name={tile?.icon} size={18} color={tile?.color} />
              </div>
              
              <Icon 
                name="ArrowUpRight" 
                size={12} 
                className={`text-muted-foreground ${tile?.hoverText} transition-colors duration-250`}
              />
            </div>
            
            <div className="space-y-0.5">
              <h3 className={`font-medium text-foreground ${tile?.hoverText} transition-colors duration-250 text-lg`}>
                {tile?.title}
              </h3>
              <p className="text-xs text-muted-foreground line-clamp-1">
                {tile?.description}
              </p>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default QuickAccessTiles;